/**
 * @file
 * Javascript for the node content editing form.
 */

var xhr;

function QueryStringToJSON(query) {
  var pairs = query.slice(1).split('&');
  var result = {};
  pairs.forEach(function (pair) {
    pair = pair.split('=');
    result[pair[0]] = decodeURIComponent(pair[1] || '');
  });
  return JSON.parse(JSON.stringify(result));
}

(function ($, Drupal) {

  'use strict';

  /**
   * Behaviors for setting summaries on content type form.
   *
   * @type {Drupal~behavior}
   *
   * @prop {Drupal~behaviorAttach} attach
   *   Attaches summary behaviors on content type edit forms.
   */
  Drupal.behaviors.cok = {
    attach: function (context) {
      var $context = $(context);
      svg4everybody();
      // TODO: Work your magic, dude
    }
  };

  Drupal.behaviors.bootstrapSelect = {
    attach: function (context, settings) {
      $('.select-picker').selectpicker();
    }
  };

  Drupal.behaviors.ajaxFilter = {
    attach: function (context) {
      var $body = $('body');
      var $filter = $('.show_filter');

      $body.once('ajaxFilterCheckbox').on('click', '.filter-form input[type=checkbox]', function (e) {
        ajaxFilter(false);
      });

      function ajaxFilter(to_top) {
        if (xhr) {
          xhr.abort();
          xhr = null;
        }
        var parameters = $('.filter-form').serialize() + '&_wrapper_format=drupal_ajax';
        xhr = $.ajax({
          method: "GET",
          url: $('.filter-form input[name=ajax_path]').val(),
          data: parameters,
          success: function(response, status) {
            // Create a Drupal.Ajax object without associating an element, a
            // progress indicator or a URL.
            var ajaxObject = Drupal.ajax({
              url: '',
              base: false,
              element: false,
              progress: false
            });
            // Then, simulate an AJAX response having arrived, and let the Ajax
            // system handle it.
            ajaxObject.success(response, status);
            Drupal.attachBehaviors();
            if (to_top) {
              jQuery('html, body').animate({ scrollTop: 0 });
            }
          }
        });
      }

      $filter.appendTo('.sortbar');
      $filter.on('click', function (e) {
        e.preventDefault();
        $('.sidebar').removeClass('hidden-xs').removeClass('hidden-sm').addClass('fullscreen-filters');
        $('#header, #hero, #footer, .layout-content, .region-highlighted').addClass('hidden-xs').addClass('hidden-sm');
      });

      $('.show_results, .filter-form-header-close').on('click', function (e) {
        e.preventDefault();
        $('.sidebar').addClass('hidden-xs').addClass('hidden-sm').removeClass('fullscreen-filters');
        $('#header, #hero, #footer, .layout-content, .region-highlighted').removeClass('hidden-xs').removeClass('hidden-sm');
      });

      var originalSortBy = $('#edit-sort');
      var sortBy = originalSortBy.once('sortBy').clone();
      sortBy.attr('id', 'edit-sort-cloned');
      sortBy.attr('aria-label', 'Sortér efter');

      sortBy.on('change', function () {
        originalSortBy.val($(this).val());
        ajaxFilter(false);
      });
      sortBy.appendTo('.sortbar');

      $body.once('ajaxFilterPager').on('click', '.ajax-filter-results .pager a', function (e) {
        e.preventDefault();
        var pairs = QueryStringToJSON($(this).attr('href'));
        if (pairs.page) {
          var page_array = pairs.page.split(',');
          var page = page_array[0];
          if (history.pushState) {
            var urlParams;
            (window.onpopstate = function () {
              var match,
                pl     = /\+/g,  // Regex for replacing addition symbol with a space
                search = /([^&=]+)=?([^&]*)/g,
                decode = function (s) { return decodeURIComponent(s.replace(pl, " ")); },
                query  = window.location.search.substring(1);

              urlParams = {};
              while (match = search.exec(query))
                urlParams[decode(match[1])] = decode(match[2]);
            })();
            urlParams['page'] = page;
            var url = window.location.href.split('?')[0];

            history.pushState({'page': page}, null, url + '?' + $.param(urlParams));
          }
          $('.filter-form input[name=page]').val(page);
          ajaxFilter(true);
        }
      });
    }
  };

  Drupal.behaviors.accordion = {
    attach: function (context) {
      $('.accordion-item .accordion-item-header:not(a)').once('accordion').on('click', function (e) {
        triggerAccordion(this, e);
      }).on('keydown', function (e) {
        if (e.which === 13) {
          triggerAccordion(this, e);
        }
      });
    }
  };
  function triggerAccordion(obj, e) {
    if (!$(e.target).is('a') || $(e.target).hasClass('ignore-click')) {
      var item = jQuery(obj).parent();
      if (!item.hasClass('open')) {
        item.addClass('open');
      }
      else {
        item.removeClass('open');
      }
    }
  }

  function triggerSocialSharing(obj, e) {
    e.preventDefault();

    var buttonHolder = $(obj).blur().closest('.share-buttons');

    var url = document.location.href;
    var title = buttonHolder.data('title');
    var description = buttonHolder.data('description');
    var link = url;

    if ($(obj).hasClass('facebook')) {
      link = 'http://www.facebook.com/sharer/sharer.php';
      link += '?u=' + encodeURIComponent(url);
      window.open(link);
    }
    else if ($(obj).hasClass('twitter')) {
      link = 'https://twitter.com/intent/tweet';
      link += '?text=' + encodeURIComponent(title);
      link += '&url=' + encodeURIComponent(url);
      window.open(link);
    }
    else if ($(obj).hasClass('linkedin')) {
      link = 'http://www.linkedin.com/shareArticle?mini=true';
      link += '&url=' + encodeURIComponent(url);
      link += '&title=' + encodeURIComponent(title);
      link += '&summary=' + encodeURIComponent(description);
      window.open(link);
    }
    else if ($(obj).hasClass('email')) {
      link = 'mailto:';
      link += '?subject=' + encodeURIComponent('cok.dk: ' + title);
      link += '&body=' + url;
      document.location.href = link;
    }
    else if ($(obj).hasClass('print')) {
      print();
    }
  }

  Drupal.behaviors.socialSharing = {
    attach: function (context) {
      // encodeURI(str)
      $(context).once('socialSharing').on('click', '.share-buttons li', function (e) {
        triggerSocialSharing(this, e);
      }).on('keydown', '.share-buttons li', function (e) {
        if (e.which === 13) {
          triggerSocialSharing(this, e);
        }
      });
    }
  };

  Drupal.behaviors.dialogColorbox = {
    attach: function (context) {
      if ($(context).find('a[data-dialog-type="colorbox"]').length > 0) {
        $(context).find('a[data-dialog-type="colorbox"]').colorbox({
          'iframe': true,
          'fixed': true,
          'href': $(this).attr('href'),
          'width': '95%',
          'height': '100%',
          'maxWidth': 1140,
          'maxHeight': '95%',
          'close': ''
          // 'title': ' <img src="'+ drupalSettings.path.baseUrl +
          // drupalSettings.path.themeUrl +'/images/icons/ssl.svg" /><span>OBS!
          // Det er helt ufarligt at angive dit CPR-nummer, da du befinder dig
          // på en sikker forbindelse. Læs mere om SSL/sikker forbindelse her:
          // <a href="https://cok.dk/ssl">cok.dk/ssl</a></span>'
        });
      }
    }
  }
})(jQuery, Drupal, drupalSettings);
